import { Button } from '@vrplatform/components';
import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { useAutomationModal } from '../hooks';
import { SelectPostAutomationModal } from '../modals';
import { useGenericTableStore } from '../stores';

export const PostPaymentsReservationsButton = ({
  filter,
  type,
  where,
}: {
  filter: Record<string, any>;
  where: Record<string, any>;
  type: Parameters<typeof useAutomationModal>[0];
}) => {
  const { hasAutomations, automations, handlers, opened, postAutomations } =
    useAutomationModal(type);

  const { allPagesSelected, selected, resetSelection } = useGenericTableStore();
  const selectedLength = Object.keys(selected).length;

  const location = useLocation();

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    resetSelection();
  }, [location.search]);

  if (!hasAutomations) return null;

  return (
    <>
      <Button
        variant="primary"
        leftIcon={'RocketIcon'}
        onClick={handlers.open}
        disabled={!allPagesSelected && !selectedLength}
      >
        Post
        {allPagesSelected
          ? ' All'
          : selectedLength
            ? ` (${selectedLength})`
            : ''}
      </Button>
      <SelectPostAutomationModal
        opened={opened}
        onClose={handlers.close}
        onAutomationSubmit={(automationIds) =>
          postAutomations({
            allPagesSelected,
            automationIds: automationIds,
            filterState: filter,
            where,
            getSelectedRowIds: () =>
              Object.entries(selected)
                .filter(([_, value]) => !!value)
                .map(([key]) => key),
            selectedItemType: type,
            skipCachedActions: false,
            skipSelectionNeccesary: false,
          })
        }
        automations={automations}
        type={type}
      />
    </>
  );
};
